module.exports = __webpack_public_path__ + "static/scale-model-of-california-route-66-museum-in-victorville-california-984de69d8e1190863c1bc5ac343ed3d1.png";